import type { AdministrativeAreaOption } from "@/components/AdministrativeAreaTreeSelect";

import type { ComboboxOption } from "../../../../InfoHub/Components/Form/Components/MultiSelectCombobox";
import type {
  ExchangeLocation,
  ExchangeLocationFormValues,
  ExchangeLocationType,
} from "../../ExchangeLocationForm/types";
import type { RepresentativeFormValues } from "../../RepresentativeForm/types";
import type { TraderDetailsStepOneFormValues } from "./TraderDetailsStepOne/types";

export type TranslationFunction = (key: string, options?: Record<string, unknown>) => string;
export type EntityId = string | number;

export const STEP_IDS = {
  DETAILS: "details",
  REPRESENTATIVES: "representatives",
  EXCHANGE_LOCATIONS: "exchangeLocations",
} as const;

export type StepId = (typeof STEP_IDS)[keyof typeof STEP_IDS];

export interface TraderRepresentativePerson {
  full_name?: string;
  first_name?: string;
  last_name?: string;
  [key: string]: unknown;
}

export interface TraderRepresentative {
  id?: number | string;
  email?: string;
  person?: TraderRepresentativePerson;
  [key: string]: unknown;
}

export type RepresentativeActionHandler = (representative: TraderRepresentative) => void;
export type TraderDetailsFormValues = TraderDetailsStepOneFormValues & ExchangeLocationFormValues;

export interface TraderDetailsFormProps {
  id?: EntityId;
  initialValues?: TraderDetailsFormValues;
  isFetching: boolean;
  isSavingProfile?: boolean;
  isFetchingTraderRepresentatives?: boolean;
  isFetchingExchangeLocations?: boolean;
  errorMessage?: string;
  fieldErrors: Record<string, unknown>;
  onClickValidateAndClose: (values: TraderDetailsFormValues) => void | Promise<unknown>;
  onClickValidateAndContinue: (
    values: TraderDetailsFormValues,
    currentStep: number
  ) => void | Promise<unknown>;
  traderRepresentatives: TraderRepresentative[];
  onClickEditRepresentative: RepresentativeActionHandler;
  onClickDeleteRepresentative: RepresentativeActionHandler;
  isDeleteRepresentativeModalOpen: boolean;
  onClickConfirmDeleteRepresentative: () => void;
  onClickCancelDeleteRepresentative: () => void;
  currentToDeleteRepresentative?: TraderRepresentative | null;
  isFetchingDeleteRepresentative: boolean;
  errorMessageDeleteRepresentative: string;
  administrativeAreas: AdministrativeAreaOption[];
  aggregatorOptions?: ComboboxOption[];
  isFetchingAggregators?: boolean;
  initialStep?: number;
  initialFormValuesRepresentative?: RepresentativeFormValues;
  isFetchingRepresentative?: boolean;
  errorMessageRepresentative?: string;
  onClickValidateRepresentativeForm: (values: RepresentativeFormValues) => void | Promise<unknown>;
  fieldErrorsRepresentative?: Record<string, unknown>;
  onClickBackRepresentativeForm: () => void;
  isOnEditRepresentative: boolean;
  onClickValidateExchangeLocationsForm: (
    values: TraderDetailsFormValues
  ) => void | Promise<unknown>;
  errorMessageExchangeLocations?: string;
  exchangeLocations: ExchangeLocation[];
  exchangeLocationTypes?: ExchangeLocationType[];
  hasCustomExchangeLocationFeatureEnabled: boolean;
}
